import { apiClient } from '@/services/api'
import endpoints from '@/services/endpoints'

export default {
  get: {
    categories: () => apiClient.get(endpoints.categories.store()),
  },
}
